import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { UserPlus, Wallet, BarChart3, CircleDollarSign, ArrowRight } from "lucide-react";

const steps = [
  { icon: UserPlus, title: "Register", desc: "Create your free account in minutes." },
  { icon: Wallet, title: "Deposit", desc: "Send BTC, USDT, or BNB to your wallet." },
  { icon: BarChart3, title: "Trading Cycle", desc: "Funds allocated to a 7-day trading cycle." },
  { icon: CircleDollarSign, title: "Collect Profits", desc: "10x profits distributed after cycle." },
];

const HowItWorksSection = () => {
  return (
    <section id="how-it-works" className="py-24">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center"
        >
          <h2 className="font-display text-3xl font-bold gradient-gold-text md:text-4xl">How It Works</h2>
          <p className="mt-4 text-muted-foreground font-body">Four simple steps to start growing your crypto.</p>
        </motion.div>

        <div className="mt-16 grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {steps.map((step, i) => (
            <motion.div
              key={step.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.12 }}
              className="relative text-center"
            >
              {/* Step number */}
              <div className="mx-auto mb-4 flex h-10 w-10 items-center justify-center rounded-full border border-gold/50 font-display text-sm font-bold text-gold">
                {i + 1}
              </div>

              {/* Icon */}
              <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-xl border border-gold-dark/30 bg-card transition-all hover:glow-gold">
                <step.icon className="h-8 w-8 text-gold" />
              </div>

              <h3 className="mt-4 font-display text-base font-semibold text-foreground">{step.title}</h3>
              <p className="mt-2 text-sm text-muted-foreground font-body">{step.desc}</p>

              {/* Connector line */}
              {i < steps.length - 1 && (
                <div className="absolute right-0 top-[4.5rem] hidden h-px w-8 translate-x-full bg-gold-dark/40 lg:block" />
              )}
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.5 }}
          className="mt-10 text-center"
        >
          <Link
            to="/how-it-works"
            className="inline-flex items-center gap-2 gradient-gold rounded-lg px-6 py-3 font-display text-sm font-semibold text-primary-foreground transition-all hover:scale-105 hover:shadow-[0_0_30px_rgba(255,215,0,0.4)]"
          >
            Learn More
            <ArrowRight className="h-4 w-4" />
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
